var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Drawer, { createDrawerTemplate } from '@/parts/drawer';
import Vue, { defineComponent } from 'vue';
export default Vue.component('drawer-customer-story-detail', 
// @ts-ignore
defineComponent({
    extends: Drawer,
    template: createDrawerTemplate({
        attributes: {
            ':id': 'id',
            ':loading': 'loading',
            ':detailData': 'detailData',
        },
    }),
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data: function () {
        return {
            loading: false,
            detailData: null,
        };
    },
    watch: {
        id: {
            immediate: true,
            handler: function (value) {
                this.detailData = null;
                if (value) {
                    this.getDetailData();
                }
            },
        },
    },
    methods: {
        getDetailData: function () {
            return __awaiter(this, void 0, void 0, function () {
                var request, data, location_1, region, locationGroup, taxo, prioritiesGoals, operationType;
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                return __generator(this, function (_m) {
                    switch (_m.label) {
                        case 0:
                            this.loading = true;
                            return [4 /*yield*/, fetch("/wp-json/wp/v2/customer-stories/".concat(this.id))];
                        case 1:
                            request = _m.sent();
                            return [4 /*yield*/, request.json()];
                        case 2:
                            data = _m.sent();
                            if (request.ok) {
                                location_1 = (_a = data === null || data === void 0 ? void 0 : data.acf) === null || _a === void 0 ? void 0 : _a.location;
                                region = (_b = data === null || data === void 0 ? void 0 : data.acf) === null || _b === void 0 ? void 0 : _b.region_details;
                                locationGroup = [location_1, region].filter(function (str) { return str; }).join(', ');
                                taxo = data === null || data === void 0 ? void 0 : data.taxonomies;
                                console.log('region == ', region);
                                prioritiesGoals = (_c = data === null || data === void 0 ? void 0 : data.acf) === null || _c === void 0 ? void 0 : _c.priorities_details;
                                operationType = Array.isArray((_d = data === null || data === void 0 ? void 0 : data.acf) === null || _d === void 0 ? void 0 : _d.operation_type_details)
                                    ? (_e = data === null || data === void 0 ? void 0 : data.acf) === null || _e === void 0 ? void 0 : _e.operation_type_details.map(function (item) { return item.name; }).join(', ')
                                    : ((_g = (_f = data === null || data === void 0 ? void 0 : data.acf) === null || _f === void 0 ? void 0 : _f.operation_type_details) === null || _g === void 0 ? void 0 : _g.name) || 'N/A';
                                this.detailData = __assign(__assign({}, data), { title: (_h = data === null || data === void 0 ? void 0 : data.title) === null || _h === void 0 ? void 0 : _h.rendered, content: (_j = data === null || data === void 0 ? void 0 : data.acf) === null || _j === void 0 ? void 0 : _j.modal_content, locationGroup: locationGroup, location: location_1, region: region, customer: ((_k = data === null || data === void 0 ? void 0 : data.acf) === null || _k === void 0 ? void 0 : _k.customer) || 'N/A', multimedia: (_l = data === null || data === void 0 ? void 0 : data.acf) === null || _l === void 0 ? void 0 : _l.multimedia, operation_type: operationType, priorities_goals: prioritiesGoals, permalink: data === null || data === void 0 ? void 0 : data.link });
                            }
                            this.loading = false;
                            return [2 /*return*/];
                    }
                });
            });
        },
    },
}));
